export default "__VITE_ASSET__0c913669__"